import React from 'react';
import { Cta1, SubpageBanner } from '../components';
import { useTranslation } from 'react-i18next';

const Vision = () => {
    const { t } = useTranslation();

    return (
        <div className="subpage-content">
            {/* Page Banner */}
            <SubpageBanner 
                title={t('vision.bannerTitle')}
                path="/about-us"
            />

            <div className="about-us-page">
                {/* Vizyon Bölümü */}
                <div className="about-vm-section">
                    <div className="container">
                        <div className="about-vm-row">
                            <div className="about-vm-content">
                                <span className="about-vm-badge">{t('aboutUs.vision.badge')}</span>
                                <h2 className="about-vm-title">{t('aboutUs.vision.title')}</h2>
                                <p className="about-vm-text">{t('aboutUs.vision.desc')}</p>
                            </div>
                            <div className="about-vm-image">
                                <img src="/assets/images/new-img/vizyon.png" alt="Vizyon" />
                            </div>
                        </div>
                    </div>
                </div>

                <Cta1
                    title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}
                />
            </div>
        </div>
    );
};

export default Vision;
